import React, {useEffect, useState} from "react";
import styled from "styled-components";
import useLockBodyScroll from "../hooks/useLockBody";
import {ReactComponent as CloseIcon} from "../assets/icons/cancel.svg";
import propTypes from "prop-types";
import {ResetButton} from "../styles/Butttons";
import {Grid, Col} from "../styles/Grid";

function Modal({children, isOpen, close, confirm, title, theme, showSuccess, type, size}) {
   const [showConfirm, setConfirm] = useState(false);
   useLockBodyScroll();

   useEffect(() => {
      document.addEventListener("keydown", escFunction, false);
      return () => {
         document.removeEventListener("keydown", escFunction, false);
      };
   });
   function escFunction(event) {
      if (event.keyCode === 27) {
         closeConfirm();
      }
   }

   const closeConfirm = () => {
      if (showSuccess) return close();
      if (!confirm) {
         if (close) close();
      } else {
         setConfirm(true);
      }
   };

   if (!isOpen) return null;

   if (type === "delete") {
      return (
         <ModalContainer>
            <div className="back-modal" />
            <div className="contentModal">
               <ComfirmStyled>
                  <Grid align="center" className="header">
                     <Col large={11}>
                        <div className="logo">
                           <img src={require("../assets/logo/logoNav.png")} alt="log" />
                        </div>
                     </Col>
                     <Col large={1}>
                        <ResetButton onClick={() => close()}>
                           <CloseIcon width="2em" height="2em" fill="grey" />
                        </ResetButton>
                     </Col>
                  </Grid>
                  <Grid className="bodyCard">{children}</Grid>
               </ComfirmStyled>
            </div>
         </ModalContainer>
      );
   }

   return (
      <>
         <ModalContainer>
            <div className="back-modal" />
            <div className="contentModal">
               <CardModal size={size} title={title} close={closeConfirm} theme={theme}>
                  {children}
               </CardModal>
            </div>
         </ModalContainer>
         {showConfirm && (
            <ModalContainer zindex="999">
               <div className="back-modal" />
               <div className="contentModal">
                  <ConfirmModal
                     title="¡Cuidado!"
                     text="No guardo sus cambios, haga click en GUARDAR para poder continuar."
                     close={() => setConfirm(false)}
                  />
               </div>
            </ModalContainer>
         )}
         {showSuccess && (
            <ModalContainer zindex="1000">
               <div className="back-modal" />
               <div className="contentModal">
                  <ConfirmModal
                     title="¡Felicidades!"
                     text="Se guardo la información exitosamente, puedes editar la información en cualquier momento."
                     tFext={confirm}
                     close={() => close()}
                  />
               </div>
            </ModalContainer>
         )}
      </>
   );
}

Modal.propTypes = {
   close: propTypes.func.isRequired,
   isOpen: propTypes.bool.isRequired,
};

const ModalContainer = styled.section`
   width: 100%;
   height: 100%;
   position: fixed;
   top: 0;
   left: 0;
   z-index: ${props => (props.zindex ? props.zindex + "100000" : "100000")};

   & .contentModal {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100001;
      position: relative;
   }

   & .back-modal {
      background: rgba(10, 10, 10, 0.5);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
   }

   @media screen and (max-width: 600px) {
      padding-top: 1em;
   }
`;

export default Modal;

// card modal

export const CardModalStyled = styled.div`
   width: 50%;
   max-width: 850px;
   background: white;
   box-sizing: border-box;

   &.big {
      width: 65%;
      max-width: 900px;
   }

   & .head {
      padding: 1em 2em;
      background-color: ${props => props.theme.back};
      box-sizing: border-box;
      color: white;
      text-align: center;
      display: grid;
      grid-template-columns: repeat(10, 1fr);
      grid-template-rows: 1fr;

      .title {
         grid-area: 1 / 1 / 2 / 11;
         font-size: 1.2em;
         user-select: none;
      }
      .close {
         grid-area: 1 / 10 / 2 / 11;
         user-select: none;
      }
   }
   .body {
      padding: 2em;
      box-sizing: border-box;
   }
`;
export const CardModal = ({title, children, close, theme, CustomHead, size}) => {
   return (
      <CardModalStyled theme={theme} className={size}>
         <div className="head">
            <div className="title">{title}</div>
            <ResetButton onClick={close} className="close">
               <CloseIcon width="1.5em" height="1,5em" fill="white" />
            </ResetButton>
         </div>

         <div className="body">{children}</div>
      </CardModalStyled>
   );
};

const ConfirmModal = ({title, text, close}) => {
   return (
      <ComfirmStyled>
         <Grid align="center" className="header">
            <Col large={11}>
               <div className="logo">
                  <img src={require("../assets/logo/logoNav.png")} alt="log" />
               </div>
            </Col>
            <Col large={1}>
               <ResetButton onClick={close}>
                  <CloseIcon width="2em" height="2em" fill="grey" />
               </ResetButton>
            </Col>
         </Grid>
         <Grid className="bodyCard">
            <Col large={12}>
               <p className="title">{title}</p>
            </Col>
            <Col large={12}>
               <p className="text">{text}</p>
            </Col>
         </Grid>
      </ComfirmStyled>
   );
};

const ComfirmStyled = styled(CardModalStyled)`
   width: 40%;
   max-width: 800px;
   padding: 2em 3em;

   & .header {
      margin-bottom: 2.5em;
   }

   p {
      margin: 0;
   }

   & .title {
      font-size: 1.5em;
      margin-bottom: 0.5em;
      color: #1c355e;
      text-transform: uppercase;
      margin-top: 0;
   }
   & .text {
      font-weight: 300;
      color: grey;
   }

   .bodyCard {
      margin-bottom: 1em;
   }

   & ${ResetButton} {
      text-align: end;
      padding: 0;
   }
`;
